import type { BrowseMarket } from '@/api/cmApi'
import { isFancyMarket } from './fancyLimitsType'
import { isBookmakerMarket } from './catalogMarkets'

export type MarketKindFilter =
  | 'all'
  | 'match_odds'
  | 'fancy'
  | 'session'
  | 'bookmaker'
  | 'other'

export const MARKET_KIND_FILTERS: { value: MarketKindFilter; label: string }[] = [
  { value: 'all', label: 'All markets' },
  { value: 'match_odds', label: 'Match Odds' },
  { value: 'fancy', label: 'Fancy' },
  { value: 'session', label: 'Session / line' },
  { value: 'bookmaker', label: 'Bookmaker' },
  { value: 'other', label: 'Other' },
]

export function isMatchOddsMarket(m: BrowseMarket): boolean {
  const t = String(m.marketType || '').toUpperCase()
  return m.name === 'Match Odds' || t === 'MATCH_ODDS' || t === 'MATCHODDS'
}

export function marketKind(m: BrowseMarket): MarketKindFilter {
  if (isBookmakerMarket(m)) return 'bookmaker'
  if (isMatchOddsMarket(m)) return 'match_odds'
  if (m.hasLineSession) return 'session'
  if (isFancyMarket(m)) return 'fancy'
  return 'other'
}

export function marketKindLabel(m: BrowseMarket): string {
  const k = marketKind(m)
  return MARKET_KIND_FILTERS.find((f) => f.value === k)?.label ?? 'Other'
}

export function filterMarketsByKind(
  markets: BrowseMarket[],
  filter: MarketKindFilter,
): BrowseMarket[] {
  if (filter === 'all') return markets
  return markets.filter((m) => marketKind(m) === filter)
}
